import React, { Fragment, useContext, useState } from 'react';
import { Modal } from '../shared/modal/modal';
import { connect } from 'react-redux';
import { NavbarItemMobile } from './navbar/NavbarItemMobile';
import { MenuOutlined, SearchOutlined } from '@ant-design/icons';
import _ from 'underscore';
import classNames from 'classnames';
import { NavLink } from 'react-router-dom';
import { Divider } from 'antd';
import { Context } from 'app/index';
import { MenuTypes } from 'app/components/navbar/Navbar';

const MenuNavItem = ({ to, name, onClick }) => {
    return (
        <NavLink
            className={({ isActive }) => {
                return classNames('nav__item d-block w-100', {
                    navbar__item_selected: isActive,
                });
            }}
            onClick={onClick}
            to={to}
        >
            <span className="navbar__item__name">{name}</span>
        </NavLink>
    );
};

const MenuNavMobile = ({ setting }) => {
    const [isOpen, setIsOpen] = useState(false);
    function onMenuItem() {
        setIsOpen(false);
    }
    const {
        settings: {
            navbar: { settings: navbarSettings },
        },
    } = useContext(Context);
    const isCompact = navbarSettings.type === MenuTypes.compact;
    return Object.keys(setting.content.pages).length ? (
        <>
            <NavbarItemMobile
                name={'Еще'}
                icon={isCompact ? <MenuOutlined /> : <SearchOutlined />}
                onClick={() => setIsOpen(true)}
            />
            <Modal
                open={isOpen}
                onCancel={() => setIsOpen(false)}
                className={'menu-mobile menu-nav-mobile'}
                width={'100%'}
            >
                <div className={'menu-mobile__header'}>Навигация</div>
                <div className={'menu-mobile__content'}>
                    {_.map(setting.content.pages, (page, index, array) => {
                        return (
                            <Fragment key={index}>
                                <MenuNavItem
                                    onClick={onMenuItem}
                                    to={`/${page.title}`}
                                    name={page.name}
                                />
                                {index !== array.length - 1 ? (
                                    <Divider />
                                ) : null}
                            </Fragment>
                        );
                    })}
                </div>
            </Modal>
        </>
    ) : null;
};

const mapStateToProps = (state) => {
    return {
        setting: state.appState.setting,
    };
};

export const ConnectedMenuNavMobile = connect(mapStateToProps)(MenuNavMobile);
